export enum WalletType {
  recharge = 'Recharges',
  reward = 'Rewards',
  coin = 'Coins',
  all = 'All',
}

export enum PaymentType {
  juryFee = 'Jury Fee',
  addMoney = 'Add Money',
}